const OrderComment = (props) => {
    const {
        t,
        formik,
        OrderCommentView,
    } = props;

    return (
        <OrderCommentView t={t} formik={formik} />
    );
};

export default OrderComment;
